import { render, staticRenderFns } from "./buoy.vue?vue&type=template&id=f3720420&scoped=true&"
import script from "./buoy.vue?vue&type=script&lang=js&"
export * from "./buoy.vue?vue&type=script&lang=js&"
import style0 from "./buoy.vue?vue&type=style&index=0&id=f3720420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3720420",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f3720420', component.options)
    } else {
      api.reload('f3720420', component.options)
    }
    module.hot.accept("./buoy.vue?vue&type=template&id=f3720420&scoped=true&", function () {
      api.rerender('f3720420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/monitor/common/buoy.vue"
export default component.exports